export function registerFeedCustomEventHandlers(saveSidebarScrollPosition) {
  document.body.addEventListener("feedReloaded", function (event) {
    const detail = event && event.detail ? event.detail : {};
    const feedID = Number(detail.feedID || 0);
    const stored = Number(detail.stored || 0);
    if (!feedID) {
      return;
    }
    const statusEl = document.getElementById("feed-reload-status-" + String(feedID));
    if (!statusEl) {
      return;
    }
    statusEl.textContent = "Reload complete: " + String(stored) + " entr" + (stored === 1 ? "y" : "ies") + " stored.";
    statusEl.classList.remove("text-red-700", "text-gray-600");
    statusEl.classList.add("text-green-700");
  });

  document.body.addEventListener("feedSettingsUpdated", function (_event) {
    if (!window.htmx) {
      return;
    }

    saveSidebarScrollPosition();

    const feedsList = document.getElementById("feeds-list");
    if (feedsList) {
      window.htmx.ajax("GET", "/feeds/list", {
        target: "#feeds-list",
        swap: "innerHTML"
      });
    }

    const sidebar = document.querySelector(".entries-sidebar");
    if (sidebar) {
      const current = window.location.pathname + window.location.search;
      window.htmx.ajax("GET", current, {
        target: ".entries-sidebar",
        swap: "outerHTML",
        select: ".entries-sidebar"
      });
    }
  });
}

export function registerDashboardBulkAppliedHandler() {
  document.body.addEventListener("dashboardBulkApplied", function () {
    if (!window.htmx) {
      return;
    }

    const current = window.location.pathname + window.location.search;
    window.htmx.ajax("GET", current, {
      target: "#entries-content",
      swap: "outerHTML",
      select: "#entries-content"
    });

    window.htmx.ajax("GET", current, {
      target: "#loaded-entry-count",
      swap: "outerHTML",
      select: "#loaded-entry-count"
    });
  });
}
